<template>
  <v-card v-if="chartObj">
    <v-card-title class="pa-2">
      <div class="subheading">
        <v-icon class="mr-2">timeline</v-icon>
        {{ chartObj.title }}
        <div style="display:none;">
          {{chartKey}}
        </div>
      </div>
      <v-spacer></v-spacer>
      <div class="caption" v-if="chartObj.data.result && chartObj.data.result.length > (chartObj.chartSettings.displayLength || 10)">
        {{ translation('chart.display-length.text', { displayLength: chartObj.chartSettings.displayLength || 10 }) }}
      </div>
      <v-btn icon small class="ma-0"
             v-if="chartObj.data.result && chartObj.data.result.length > (chartObj.chartSettings.displayLength || 10)"
             @click.stop="openDialog('chart-line-render', chartObj)">
        <v-icon>fullscreen</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="px-0">
      <div class="loader-wrapper" v-if="!chartObj.loaded">
        <base-loader></base-loader>
      </div>
      <div v-else class="chart-wrapper">
        <div v-if="chartObj.data.result && chartObj.data.result.length">
          <chart-line-render :chart-key="chartKey"></chart-line-render>
          <div class="export-menu"
               v-if="chartObj.data.result && chartObj.data.result.length
                 && chartObj.export && chartObj.exportTo && chartObj.exportTo.length">
            <export-chart-menu :chart-obj="chartObj"></export-chart-menu>
          </div>
        </div>
        <div v-else class="headline">{{ translation('chart.no-chart-data') }}</div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { eventBus } from '@/eventBus'
import BaseLoader from '@/components/loaders/BaseLoader'
import ChartLineRender from '@/components/charts/ChartLineRender'
import ExportChartMenu from '@/components/charts/ExportChartMenu'
import { mapGetters } from 'vuex'

export default {
  name: 'chartLine',
  components: {
    BaseLoader,
    ChartLineRender,
    ExportChartMenu
  },
  props: {
    chartKey: { type: String, required: true }
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['translation']),
    chartObj: {
      get () { return this.$store.getters.getChartByKey(this.chartKey) }
    }
  },
  created () {
    eventBus.$on('update-dashboard', () => {
      this.$log.info('Fetching chart', 'line', this.chartObj.key)
      this.$store.dispatch('fetchChartData', {
        key: this.chartObj.key,
        settings: this.chartObj.chartSettings,
        filters: this.$store.getters.isGenericGen ? this.$store.getters.selectedFiltersGen : this.$store.getters.selectedFilters,
        pagination: this.chartObj.pagination/* ,
        withoutCount: true */
      })
    })
  },
  destroyed () {
    eventBus.$off('update-dashboard')
  },
  methods: {
    openDialog (chartType, chartObj) {
      let dialogData = {
        chartType: chartType,
        chartObj: chartObj
      }
      this.$emit('open-dialog', dialogData)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .loader-wrapper {
    position: relative;
    height: 50px;
  }
  .chart-wrapper {}
  .export-menu {
    position: absolute;
    bottom: 0;
    right: 0;
  }
</style>
